module.exports = __webpack_public_path__ + "static/media/6@2x.288976ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_150/img/6@2x.png
// module id = 1478
// module chunks = 0